import "./modal-influencer-reels.js";

(function () {
  "use strict";

  if (!customElements.get("influencer-video-reels")) {
    class InfluencerVideoReels extends HTMLElement {
      constructor() {
        super();
        this.slidesData = [];
        this.boundOpenFromEvent = null;
        this.boundCardClick = null;
        this.boundCardPointer = null;
      }

      connectedCallback() {
        this.parseSlidesJson();
        if (!this.slidesData.length) return;

        const ds = this.dataset;
        this.options = {
          autoAdvanceOnEnd: ds.autoAdvanced === "true",
          showUnmute: ds.showUnmute !== "false",
          showPlayPause: ds.showPlayPause !== "false",
          swipeInfo: "Swipe",
          reviewedLabel: ds.reviewedLabel || "",
          shopTitle: ds.shopTitle || "",
        };

        this.boundOpenFromEvent = (e) => {
          const idx =
            typeof e.detail?.index === "number" ? e.detail.index : null;
          if (idx === null || idx < 0 || idx >= this.slidesData.length) return;
          this.openModalAt(idx);
        };
        this.addEventListener(
          "influencer-reels:open",
          this.boundOpenFromEvent,
        );

        const openFromCard = (e) => {
          if (e.target.closest("a.wt-influencer-reels__handle")) return;
          const btn = e.target.closest(".wt-influencer-reels__card-btn");
          if (!btn || !this.contains(btn)) return;
          const card = btn.closest("[data-slide-index]");
          if (!card) return;
          const idx = parseInt(card.getAttribute("data-slide-index"), 10);
          if (Number.isNaN(idx)) return;
          if (e.pointerType === "mouse" && e.button !== 0) return;
          e.preventDefault();
          e.stopPropagation();
          this.openModalAt(idx);
        };

        /** Pointerdown + capture opens before Swiper touch logic; click keeps keyboard activation */
        this.boundCardPointer = openFromCard;
        this.boundCardClick = openFromCard;
        this.addEventListener("pointerdown", this.boundCardPointer, true);
        this.addEventListener("click", this.boundCardClick, true);

        this.maybeOpenFromUrl();
      }

      disconnectedCallback() {
        if (this.boundOpenFromEvent) {
          this.removeEventListener(
            "influencer-reels:open",
            this.boundOpenFromEvent,
          );
        }
        if (this.boundCardClick) {
          this.removeEventListener("click", this.boundCardClick, true);
        }
        if (this.boundCardPointer) {
          this.removeEventListener(
            "pointerdown",
            this.boundCardPointer,
            true,
          );
        }
      }

      parseSlidesJson() {
        const el = this.querySelector("[data-influencer-reels-json]");
        if (!el) return;
        try {
          const raw = el.textContent.trim();
          this.slidesData = raw ? JSON.parse(raw) : [];
        } catch (e) {
          console.warn("[influencer-video-reels] Invalid JSON payload", e);
          this.slidesData = [];
        }
      }

      maybeOpenFromUrl() {
        const param = (this.dataset.urlParam || "reel").trim();
        if (!param) return;

        try {
          const search =
            window.location.search.startsWith("?") ?
              window.location.search.slice(1)
            : window.location.search;
          const params = new URLSearchParams(search);
          const raw = params.get(param);
          if (raw == null || raw === "") return;

          const idx = parseInt(raw, 10);
          if (Number.isNaN(idx) || idx < 1) return;

          const zeroBased = idx - 1;
          if (zeroBased >= this.slidesData.length) return;

          requestAnimationFrame(() => {
            setTimeout(() => this.openModalAt(zeroBased), 400);
          });
        } catch (_) {
          /* ignore */
        }
      }

      openModalAt(index) {
        if (!this.slidesData.length) return;
        if (document.querySelector(".video-reels-modal")) return;

        const modal = document.createElement("modal-influencer-reels");
        modal.sectionRoot = this;
        modal.slides = this.slidesData;
        const isMobile = window.matchMedia("(max-width: 899px)").matches;
        modal.config = {
          initialSlide: index,
          slidesPerView: 1,
          centeredSlides: true,
          direction: isMobile ? "vertical" : "horizontal",
          loop: this.slidesData.length > 2,
          autoAdvanceOnEnd: this.options.autoAdvanceOnEnd,
          showUnmute: this.options.showUnmute,
          showPlayPause: this.options.showPlayPause,
          swipeInfo: this.options.swipeInfo,
          reviewedLabel: this.options.reviewedLabel,
          shopTitle: this.options.shopTitle,
        };
        try {
          modal.open();
        } catch (err) {
          console.error("[influencer-video-reels] Modal failed to open", err);
        }
      }
    }

    customElements.define("influencer-video-reels", InfluencerVideoReels);
  }
})();
